import { useEffect } from "react";

const FEED_ID = process.env.REACT_APP_BEHOLD_FEED_ID || "SpRrCh7bT3TRRpxPYo0C";

/**
 * Live Instagram feed via Behold.so.
 * Loads the Behold widget script once, then renders the custom element.
 * The widget auto-updates from behold.so cache (typically every few hours).
 */
export default function BeholdFeed() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.__bhldScript) return;
    window.__bhldScript = true;
    const s = document.createElement("script");
    s.type = "module";
    s.src = "https://w.behold.so/widget.js";
    document.head.appendChild(s);
  }, []);

  return (
    <div className="behold-wrap" data-testid="behold-feed">
      {/* Custom element from Behold — React 19 supports web components natively */}
      <behold-widget feed-id={FEED_ID}></behold-widget>
    </div>
  );
}
